/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import {
    AdcPageWidgetComponent,
    AdcSetupComponent,
    AddBillingContactComponent,
    AddPaymentMethodComponent,
    AddUsersComponent,
    BackupPageWidgetComponent,
    CheckoutHelperComponent,
    CmNotificationsComponent,
    CmProductBoxComponent,
    MarketingBannerComponent,
    SelectPaymentCardComponent,
    SelectProductComponent,
    TagsComponent
} from './components';
import { AdcsWidgetComponent } from './components/widgets/dashboard-widgets/adcs/adcs-widget.component';
import { AdvertWidgetComponent } from './components/widgets/dashboard-widgets/advert-widget/advert-widget.component';
import { AlternativeStatePageComponent } from './components/empty-state-page/alternative-state-page.component';
import {
    AuditingApiService,
    BillingApiService,
    NamespacesApiService,
    PortalRbacApiService,
    ResourcesApiService,
    SecurityApiService,
    ShuttleApiService,
    SupportApiService
} from './http';
import { BackupUtilsService, ConcertinaService, DashboardService } from './services/component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import {
    ConcertinaContainerComponent,
    ConcertinaContentComponent,
    ConcertinaItemComponent,
    ConcertinaTitleComponent
} from './components/concertina';
import { ConnectionDetailsService } from '../../../core/services';
import {
    FeaturesWidgetComponent
} from './components/widgets/dashboard-widgets/features-widget/features-widget.component';
import { GuidesWidgetComponent } from './components/widgets/dashboard-widgets/guides-widget/guides-widget.component';
import { NamespaceWidgetComponent } from './components/widgets/dashboard-widgets/namespaces/namespace-widget.component';
import { NgModule } from '@angular/core';
import { PortalResolverGuard } from './guards/portal-resolver-guard.service';
import {
    PortalWhatsNewComponent
} from './components/widgets/dashboard-widgets/portal-whats-new/portal-whats-new.component';
import {
    QuickLinkWidgetComponent
} from './components/widgets/dashboard-widgets/quick-link-widget/quick-link-widget.component';
import { RouterModule } from '@angular/router';
import { SchedulesWidgetComponent } from './components/widgets/dashboard-widgets/schedules/schedules-widget.component';
import {
    SecurityWidgetComponent
} from './components/widgets/dashboard-widgets/security-widget/security-widget.component';
import { SharedModule } from '../../../core/shared.module';
import { ShuttleSelectSupplierComponent } from './components/addShuttleSelectSupplier/shuttle-select-supplier.component';
import { StorageWidgetComponent } from './components/widgets/dashboard-widgets/storage-widget/storage-widget.component';
import { UserWidgetComponent } from './components/widgets/dashboard-widgets/user-widget/user-widget.component';

/**
 * Shared imports between pages
 * Note: You must define a new dep. as an IMPORT/DECLARATION AND EXPORT it!
 */
@NgModule({
    imports: [
        CarouselModule,
        SharedModule,
        RouterModule
    ],
    declarations: [
        AdcSetupComponent,
        AddBillingContactComponent,
        AddPaymentMethodComponent,
        AddUsersComponent,
        AlternativeStatePageComponent,
        CheckoutHelperComponent,
        CmNotificationsComponent,
        CmProductBoxComponent,
        ConcertinaContainerComponent,
        ConcertinaContentComponent,
        ConcertinaItemComponent,
        ConcertinaTitleComponent,
        MarketingBannerComponent,
        SelectPaymentCardComponent,
        SelectProductComponent,
        ShuttleSelectSupplierComponent,
        TagsComponent,
        // Widgets
        AdcPageWidgetComponent,
        AdcsWidgetComponent,
        AdvertWidgetComponent,
        FeaturesWidgetComponent,
        GuidesWidgetComponent,
        NamespaceWidgetComponent,
        PortalWhatsNewComponent,
        QuickLinkWidgetComponent,
        SchedulesWidgetComponent,
        SecurityWidgetComponent,
        StorageWidgetComponent,
        UserWidgetComponent,
        // Page widgets
        AdcPageWidgetComponent,
        BackupPageWidgetComponent
    ],
    exports: [
        // Imports
        CarouselModule,
        SharedModule,
        // Declarations
        AdcSetupComponent,
        AddUsersComponent,
        AlternativeStatePageComponent,
        CheckoutHelperComponent,
        CmNotificationsComponent,
        CmProductBoxComponent,
        ConcertinaContainerComponent,
        ConcertinaContentComponent,
        ConcertinaItemComponent,
        ConcertinaTitleComponent,
        MarketingBannerComponent,
        SelectPaymentCardComponent,
        SelectProductComponent,
        ShuttleSelectSupplierComponent,
        TagsComponent,
        // Widgets
        AdcsWidgetComponent,
        AdvertWidgetComponent,
        FeaturesWidgetComponent,
        GuidesWidgetComponent,
        NamespaceWidgetComponent,
        PortalWhatsNewComponent,
        QuickLinkWidgetComponent,
        SchedulesWidgetComponent,
        SecurityWidgetComponent,
        StorageWidgetComponent,
        UserWidgetComponent,
        // Page widgets
        AdcPageWidgetComponent,
        BackupPageWidgetComponent
    ],
    providers: [
        AuditingApiService,
        BackupUtilsService,
        BillingApiService,
        ConcertinaService,
        ConnectionDetailsService,
        DashboardService,
        NamespacesApiService,
        PortalRbacApiService,
        PortalResolverGuard,
        ResourcesApiService,
        SecurityApiService,
        ShuttleApiService,
        SupportApiService
    ]
})

export class CentraliseManagementSharedModule {
}
